import type { SavedObjectivesManager } from '@/state/experiments/useSavedObjectives';
import { LoadSavedObjectivesDialog } from './LoadSavedObjectivesDialog';
import { SaveObjectivesDialog } from './SaveObjectivesDialog';
import { SavedObjectivesMenu } from './SavedObjectivesMenu';

export { ObjectivesSourceLine } from './ObjectivesSourceLine';

type SavedObjectivesProps = { manager: SavedObjectivesManager };

/** The "Saved objectives" menu for the card header, and whichever of its dialogs is open. */
export const SavedObjectives = ({ manager }: SavedObjectivesProps) => {
  if (!manager.canEdit) return null;
  const { dialog } = manager;

  return (
    <>
      <SavedObjectivesMenu manager={manager} />
      {dialog?.kind === 'save' ? <SaveObjectivesDialog manager={manager} initialMode={dialog.mode} /> : null}
      {dialog?.kind === 'load' ? (
        <LoadSavedObjectivesDialog manager={manager} preselectedId={dialog.preselectedId} />
      ) : null}
    </>
  );
};
